export default "__VITE_PUBLIC_ASSET__1959057e__"